import React from 'react';
import { Outlet } from 'react-router-dom';
import { TestConfigSidebarProvider } from './TestConfigSidebarContext';

/** The config-rail collapse context lives here so the list and the scoped workspace share it. */
export const TestsLayout: React.FC = () => {
  return (
    <TestConfigSidebarProvider>
      <Outlet />
    </TestConfigSidebarProvider>
  );
};

export default TestsLayout;
